<template>
  <v-card class="mb-4" :class="getSaleClass(sale)">
    <v-card-text class="pt-2">
      <v-row align="center">
        <!-- Selection Checkbox -->
        <v-col cols="auto">
          <v-checkbox
            :model-value="selected"
            @update:model-value="$emit('selection-changed', sale.ID)"
            hide-details
            density="compact"
          ></v-checkbox>
        </v-col>

        <!-- Sale Link -->
        <v-col cols="auto">
          <router-link
            :to="`/sales/${sale.ID}`"
            class="text-decoration-none"
          >
            {{ sale.ID }}
          </router-link>
        </v-col>

        <!-- Created Date -->
        <v-col cols="1">
          <span class="ml-1">{{ formatDate(sale.CreatedDate) }}</span>
        </v-col>

        <!-- PO Number -->
        <v-col cols="2">
          <span class="ml-1">{{ sale.PONumber }}</span>
        </v-col>

        <!-- Vendor -->
        <v-col cols="2">
          <span class="ml-1">{{ sale.Vendor }}</span>
        </v-col>

        <!-- Tracking Number -->
        <v-col cols="3">
          <span class="ml-1">{{ sale.trackingnumber || '—' }}</span>
          <span class="ml-1">{{ sale.ShippingService || '—' }}</span>
        </v-col>

        <!-- Status -->
        <v-col cols="1">
          <span class="ml-1">{{ sale.Status || '—' }}</span>
        </v-col>

        <!-- Send Message Button -->
        <v-col cols="auto">
          <v-btn
            color="primary"
            prepend-icon="mdi-message"
            @click="$emit('send-message', sale)"
          >
            Message
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { getSaleClass } from '@/utils/SaleClass'

defineProps({
  sale: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

defineEmits(['selection-changed', 'update:sale', 'send-message'])

const formatDate = (date) => {
  if (!date) return '—'
  return new Date(date + " 00:00:00").toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}
</script>
